/**
 * Builds a public Telegram URL from a handle or full URL (mirrors backend logic).
 */
export function buildTelegramUrl(value: string | null | undefined): string | null {
  const raw = value?.trim();
  if (!raw) {
    return null;
  }
  if (/^https?:\/\//i.test(raw)) {
    return raw;
  }
  const handle = raw
    .replace(/^@/, '')
    .replace(/^https?:\/\/(www\.)?(t\.me|telegram\.me)\//i, '')
    .replace(/\/$/, '');
  if (!handle) {
    return null;
  }
  return `https://t.me/${encodeURIComponent(handle)}`;
}
